import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

import { auth } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import {
    GoogleAuthProvider,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
} from 'firebase/auth';

export default function SignIn() {
    const [user, loading] = useAuthState(auth);

    const [mode, setMode] = useState('signin');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [info, setInfo] = useState('');

    if (loading) return <p>Loading…</p>;
    if (user) return <Navigate to="/" replace />;

    async function withBusy(fn) {
        if (busy) return;
        setBusy(true);
        setError('');
        setInfo('');
        try {
            await fn();
        } catch (err) {
            setError(err.message ?? String(err));
        } finally {
            setBusy(false);
        }
    }

    function handleEmail(e) {
        e.preventDefault();
        if (!email || !password) return;
        withBusy(() => mode === 'signin'
            ? signInWithEmailAndPassword(auth, email, password)
            : createUserWithEmailAndPassword(auth, email, password));
    }

    function handleReset() {
        if (!email) {
            setError('Enter your email above first, then click "Forgot password?".');
            return;
        }
        withBusy(async () => {
            await sendPasswordResetEmail(auth, email);
            setInfo(`Password reset email sent to ${email}.`);
        });
    }

    function switchMode(next) {
        setMode(next);
        setError('');
        setInfo('');
    }

    return (
        <div>
            <h1>Scav Hunt Central</h1>

            <button
                disabled={busy}
                onClick={() => withBusy(() => signInWithPopup(auth, new GoogleAuthProvider()))}
            >
                Continue with Google
            </button>

            <h3>or with email</h3>

            <form onSubmit={handleEmail}>
                <p>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </p>
                <p>
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </p>
                <button type="submit" disabled={busy}>
                    {mode === 'signin' ? 'Sign in' : 'Create account'}
                </button>
            </form>

            <p>
                {mode === 'signin' ? (
                    <>
                        New here?{' '}
                        <a href="#" onClick={(e) => { e.preventDefault(); switchMode('signup'); }}>Create an account</a>
                        {' · '}
                        <a href="#" onClick={(e) => { e.preventDefault(); handleReset(); }}>Forgot password?</a>
                    </>
                ) : (
                    <>
                        Already have an account?{' '}
                        <a href="#" onClick={(e) => { e.preventDefault(); switchMode('signin'); }}>Sign in</a>
                    </>
                )}
            </p>

            {error && <p style={{ color: 'red' }}>{error}</p>}
            {info && <p style={{ color: 'green' }}>{info}</p>}
        </div>
    );
}
